import React from 'react'

import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import Icon from '@material-ui/core/Icon';
import Grid from '@material-ui/core/Grid';
import { DateRangePicker } from 'react-dates';
import moment from 'moment';
import withWidth from '@material-ui/core/withWidth';

class DRP extends React.Component {
	state={
		startDate: null,
		endDate: null,
		focusedInput: null,
		received: false
	}

	handleChange(e) {
		const { startDate, endDate } = e
		this.setState({ startDate, endDate })
	}

	resetDates() {
		this.setState({
			startDate: null,
			endDate: null
		})
	}

	componentDidUpdate(prevProps, prevState) {

		if ( this.state.received && this.state.startDate === prevState.startDate && this.state.endDate === prevState.endDate ) {
			return
		}

		const { startDate, endDate } = this.state

		if ( this.state.received ) {
			this.props.handleChange({
				from: startDate === null ? null : startDate.startOf('day').utc().format(),
				to: endDate === null ? null : endDate.endOf('day').utc().format()
			})
		} else if ( !this.state.received && this.props.startDate !== null ) {
			const from = moment(this.props.startDate)
			const to   = this.props.endDate ? moment(this.props.endDate) : moment()
			this.setState({received: true, startDate: from, endDate: to})
		}
		if ( this.props.startDate !== prevProps.startDate || this.props.endDate !== prevProps.endDate) {
			const from = moment(this.props.startDate)
			const to   = this.props.endDate ? moment(this.props.endDate) : moment()
			this.setState({ startDate: from, endDate: to})
		}
	}

	renderDatePresets() {
		const presets = [
			{
				text: "Today",
				start: moment().startOf('day'),
				end: moment().endOf('day')
			},
			{
				text: "This Week",
				start: moment().startOf('week'),
				end: moment()
			},
			{
				text: "Last Week",
				start: moment().subtract(1, 'weeks').startOf('week'),
				end: moment().subtract(1, 'weeks').endOf('week')
			},
			{
				text: "This Month",
				start: moment().startOf('month'),
				end: moment()
			},
			{
				text: "Last Month",
				start: moment().subtract(1, 'months').startOf('month'),
				end: moment().subtract(1, 'months').endOf('month')
			},
			{
				text: "This Year",
				start: moment().startOf('year'),
				end: moment()
			},
			{
				text: "Last Year",
				start: moment().subtract(1, 'years').startOf('year'),
				end: moment().subtract(1, 'years').endOf('year')
			},
			{
				text: "All Time",
				start: this.props.timeStart ? moment(this.props.timeStart) : null,
				end: moment()
			},
		]
		return (
			<Grid container spacing={24} justify="center">
				<Grid container item md={8} xs={12} className="drp-presets-container">
					{presets.map(({ text, start, end }) => {
						return (
							<Grid item xs={6} md={3} key={text} className="calendar-link">
								<a
									href=""
									onClick={(e) => {
										e.preventDefault()
										this.setState({ startDate: start, endDate: end, focusedInput: null })

								}}>
									{text}
								</a>
							</Grid>
						);
					})}
				</Grid>
			</Grid>
		)
	}


	render(){
		const {focusedInput} = this.state
		const {startDate, endDate, startLabel, endLabel} = this.props
		const numberOfMonths = (this.props.width === 'sm' || this.props.width === 'xs') ? 1 : 2
		const withPortal = (this.props.width === 'sm' || this.props.width === 'xs')
		// const withPortal = this.props.withPortal !== undefined ? this.props.withPortal : false

		return (
			<div className="dashboard-range-picker">
				<DateRangePicker
					showClearDates
					noBorder
					isOutsideRange={day => {
						let today = new Date();
						return (day > today)
					} }
					startDateId="startDate"
					endDateId="endDate"
					displayFormat="DD/MM/YYYY"
					minimumNights={0}
					startDatePlaceholderText={startLabel ? startLabel : "From"}
					endDatePlaceholderText={endLabel ? endLabel : "To"}
					startDate={startDate ? moment(startDate).utc() : null}
					endDate={endDate ? moment(endDate).utc() : null}
					withPortal={withPortal}
					hideKeyboardShortcutsPanel
					onDatesChange={this.handleChange.bind(this)}
					focusedInput={focusedInput}
					numberOfMonths={numberOfMonths}
					onFocusChange={(focusedInput) => { focusedInput !== this.state.focusedInput && this.setState({ focusedInput })}}
					customArrowIcon={<Icon style={{fontSize:"14px", color: "rgba(0,0,0,.54)"}}>play_arrow</Icon>}
					renderCalendarInfo={this.renderDatePresets.bind(this)}
				/>
			</div>
		)
	}
}

export default withWidth()(DRP)



// WEBPACK FOOTER //
// ./src/js/components/inputs/DashboardRangePicker.js